/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import PricingForm from './PricingForm';
import './ProRoomForm.css';

import {
  listLocationsAuth,
  upload,
} from '../../actions';


let fieldNames = [
  'name',
  'description',
  'locationId',
  'minPeople',
  'maxPeople',
  'difficulty',
  'minutes',
  'privacy',
  'scary',
];

function fieldNameTrans(f) {
  if (f == 'locationId') {
    return 'locationUgcId';
  }
  return f + 'Ugc';
}

let ugcFieldNames = fieldNames.map(fieldNameTrans);


class ImageForm extends OzFormComponent {
  static fields = [
    'url',
  ]

  renderBody() {
    return (
      <div className="ImageForm">
        {this.renderFormGroup(null, 'image', 'url')}
      </div>
    );
  }
}


class ProRoomForm extends OzFormComponent {

  static fields = ugcFieldNames.concat(['images', 'pricing']);

  options = {
    images: {
      init: {
        url: null,
      }
    },
  };

  constructor(props) {
    super(props);
    for (let field of fieldNames) {
      let fieldUgc = fieldNameTrans(field);
      if (!this.state[fieldUgc] && props.values[field]) {
        this.state[fieldUgc] = props.values[field];
      }
    }
  }

  componentDidMount() {
    this.props.listLocationsAuth({ mine: 1, noGeo: 1 }, { targetKey: 'locationAuth' });
  }

  setPriceValues(values) {
    console.log('setPriceValues', values);
    this.setState({ pricing: values })
  }

  renderImages() {
    let images = this.state.images || [];
    let i = 0;
    let nodes = images.map(image => {
      let index = i;
      i++;
      return (
        <ImageForm
          key={image.id}
          index={image.id}
          errors={this.props.errors ? this.props.errors.images[index] : null}
          part={true}
          values={image}
          cancelRender={() => <Button bsSize="sm">Remove</Button>}
          onCancel={() => this.removeMany(image.id, 'images')}
          onChange={(values) => this.updateMany(image.id, values, 'images')}
          upload={this.props.upload}
        />
      );
    });

    return (
      <div className="images-wrapper">
        {nodes}
      </div>
    );
  }

  renderBody() {
    if (!this.props.locations) return null;

    let locationOptions = this.props.locations.items.map(l => [l.id, l.company + ', ' + l.address]);

    let privacyOptions = [
      ['always', 'Always private'],
      ['fee', 'Extra fee for private booking'],
      ['no', 'Public'],
    ];

    let scaryOptions = [
      ['no', 'Not a scary room'],
      ['little', 'A little scary'],
      ['scary', 'Yes! This is a scary room'],
    ];

    return (
      <div className="ProRoomForm">
        {this.renderFormGroup('Location (required)', 'select', 'locationUgcId', locationOptions)}

        {this.renderFormGroup('Name (required)', 'text', 'nameUgc')}

        {this.renderFormGroup('Description (required)', 'textarea', 'descriptionUgc')}

        {this.renderFormGroupPair(
          ['Min players (required)', 'selectNumber', 'minPeopleUgc', { min: 1, max: 25 }],
          ['Max players (required)', 'selectNumber', 'maxPeopleUgc', { min: 1, max: 25 }])}

        {this.renderFormGroup('Game length in minutes (required)', 'selectNumber', 'minutesUgc', { min: 5, max: 300, incr: 5, suffix: 'minute', suffixPlural: 'minutes' })}

        {this.renderFormGroup('Difficulty (optional)', 'text', 'difficultyUgc', { helptext: 'Describe the difficulty of this room in any format that you use.' })}

        {this.renderImages()}
        <div className="add-image">
          <Button onClick={() => this.addMany('images')}>Add Image</Button>
        </div>

        <div className="pricing">
          <div className="header">Pricing</div>
          {this.renderFormGroup('Are bookings private?', 'radio', 'privacyUgc', privacyOptions)}
          <PricingForm
            values={this.props.values.pricing || {}}
            privacy={this.state.privacyUgc}
            minPeople={this.state.minPeopleUgc}
            maxPeople={this.state.maxPeopleUgc}
            onChange={(values) => this.setPriceValues(values)}
          />
        </div>

      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    locations: state.list.locationAuth,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listLocationsAuth,
    upload,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProRoomForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/ProRoomForm.js
 **/